import { authorizedApiClient } from "../config";
import type { BusinessContext, BusinessContextPatch } from "../../types/businessContext";

export const getBusinessContext = async ({
  workspace_id,
}: {
  workspace_id: string;
}) => authorizedApiClient.get<BusinessContext>(`/${workspace_id}/business_context`);

export const patchBusinessContext = async ({
  workspace_id,
  patch,
}: {
  workspace_id: string;
  patch: BusinessContextPatch;
}) => authorizedApiClient.patch<BusinessContext>(`/${workspace_id}/business_context`, patch);
